import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { UIText } from '../typography';

const Container = styled.div`
  width: 100%;
  z-index: 500;
  margin: 0 auto;
`;

const Title = styled(UIText).attrs({ size: 'lg' })`
  color: ${theme.colors.primary.graysRed};
  font-weight: bold;
  margin-bottom: ${theme.spacings[3].rem};
`;

const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

const ListItem = styled(UIText).attrs({ size: 'md' })`
  display: block;
  color: ${theme.colors.neutrals.solidGrays[4]};
  margin-bottom: ${theme.spacings[2].rem};

  strong {
    color: ${theme.colors.primary.graysGray};
    font-weight: 2000;
  }

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

type SearchResult = {
  id: string;
  value: string;
};

type SuggestedSearchProps = PropsWithChildren<{
  titleText: string;
  searchResults: SearchResult[];
  noResultsMessage?: string;
  onClick: (value: string) => void;
}>;

export const SuggestedSearchResults: React.FC<SuggestedSearchProps> = ({
  titleText,
  searchResults,
  noResultsMessage,
  onClick,
}) => {
  if (
    searchResults === undefined ||
    searchResults === null ||
    searchResults.length === 0
  ) {
    return (
      <Container>
        <Title>{titleText}</Title>
        <UIText size="sm">{noResultsMessage}</UIText>
      </Container>
    );
  } else {
    return (
      <Container>
        <Title>{titleText}</Title>
        {
          <>
            <List>
              {searchResults.slice(0, 8).map(({ id, value }) => (
                <>
                  <ListItem
                    key={value}
                    as="li"
                    onClick={() => onClick(id)}
                    dangerouslySetInnerHTML={{
                      __html: value.replaceAll('mark', 'strong').split('*')[0],
                    }}
                  />

                  <span
                    dangerouslySetInnerHTML={{ __html: value.split('*')[1] }}
                  ></span>
                </>
              ))}
            </List>
          </>
        }
      </Container>
    );
  }
};
